import { FileItem } from '@src/components/FilePreviewList/FileItem'
import { makeAutoObservable } from 'mobx'

export class FilePreviewListStore {
    page: number = 1
    pageSize: number = 10
    files: FileItem[] = []  

    get visibleItems() {
        return this.files.slice(this.startRange, this.endRange)
    }

    private get startRange() {
        return (this.page - 1) * this.pageSize
    }

    private get endRange() {
        return this.startRange + this.pageSize
    }

    constructor() {
        makeAutoObservable(this)
    }

    setFiles(files: FileItem[]) {
        this.files = files
    }

    setPage(page: number) {
        this.page = page
    }
}
